<template>
    <section>
        <div class="event-box">
            <div v-if="edit">
                <div class="data">
                    <select v-model="event.comparision" class="control-inline form-control">
                        <option v-for="option in compareOptions" v-bind:value="option.value">
                            {{ $t(option.text) }}
                        </option>
                    </select>
                    <input v-model="event.liters" type="text" class="control-inline form-control"> {{$t(unit === 'liters' ? 'message.liters' : 'message.watts')}}
                    za poslednich <input v-model="event.minutes" type="text" class="control-inline form-control"> minut
                </div>
                <div class="actions">
                    <b-btn @click="save" type="success">{{$t('message.save')}}</b-btn>
                    <b-btn @click="remove"><i class="fa fa-trash"></i></b-btn>
                </div>
            </div>
            <div v-else>
                <div class="data">
                    {{$t(translate[event.comparision])}} {{event.liters}} {{$t(unit === 'liters' ? 'message.liters' : 'message.watts')}}
                </div>
                <div class="actions">
                    <b-btn @click="edit=true"><i class="fa fa-pencil"></i></b-btn>
                    <b-btn @click="remove"><i class="fa fa-trash"></i></b-btn>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import Base from './Base'

    export default {
        name: 'LastMinutes',
        extends: Base
    }
</script>

<style scoped>
    @import 'base.css';
</style>
